import React from 'react';
import {
  Box,
  Container,
  Typography,
  Paper,
  Button,
  useTheme,
} from '@mui/material';
import {
  Construction as ConstructionIcon,
  ArrowBack as ArrowBackIcon,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const PrivacyPage: React.FC = () => {
  const navigate = useNavigate();
  const theme = useTheme();

  return (
    <Box>
      {/* Hero Section */}
      <Box
        sx={{
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          py: { xs: 6, md: 10 },
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        <Container maxWidth="md">
          <Box sx={{ textAlign: 'center' }}>
            <Typography
              variant="h2"
              component="h1"
              fontWeight="bold"
              sx={{
                fontSize: { xs: '2rem', md: '3rem' },
                mb: 2,
              }}
            >
              Privacy Policy
            </Typography>
            <Typography
              variant="h6"
              sx={{ opacity: 0.9 }}
            >
              How we collect, use, and protect your data
            </Typography>
          </Box>
        </Container>
      </Box>

      {/* Content Section */}
      <Container maxWidth="sm" sx={{ py: 8 }}>
        <Paper
          sx={{
            p: { xs: 4, md: 6 },
            textAlign: 'center',
            bgcolor: theme.palette.mode === 'light' ? 'grey.50' : 'background.paper',
          }}
        >
          <Box
            sx={{
              bgcolor: 'warning.main',
              width: 80,
              height: 80,
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mx: 'auto',
              mb: 3,
            }}
          >
            <ConstructionIcon sx={{ fontSize: 40, color: 'white' }} />
          </Box>

          <Typography variant="h4" fontWeight="bold" gutterBottom>
            Coming Real Soon!
          </Typography>

          <Typography
            variant="body1"
            color="text.secondary"
            sx={{ lineHeight: 1.8, mb: 4 }}
          >
            Your privacy matters to us. We're crafting a comprehensive Privacy Policy
            that clearly explains how we collect, use, and protect your data.
            It'll be ready before you know it!
          </Typography>

          <Box
            sx={{
              p: 2,
              borderRadius: 1,
              bgcolor: theme.palette.mode === 'light' ? 'grey.100' : 'grey.800',
              mb: 4,
            }}
          >
            <Typography variant="body2" color="text.secondary">
              Rest assured, we take data protection seriously. While our formal
              policy is being finalized, we're committed to handling your
              information with the utmost care.
            </Typography>
          </Box>

          <Button
            variant="outlined"
            startIcon={<ArrowBackIcon />}
            onClick={() => navigate('/')}
            sx={{ fontWeight: 600 }}
          >
            Back to Home
          </Button>
        </Paper>
      </Container>
    </Box>
  );
};

export default PrivacyPage;
